import React,{ FC, useEffect, useMemo, useState } from "react"
import { Image, List, Mask } from "antd-mobile"
import { CloseOutline } from "antd-mobile-icons"
import styles from "./index.module.less"
import { certificate_title } from "~src/constants/network"
import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { getCertificateList, getIndividualList } from "~src/service/welfare"
import { useGetWelfareRid } from "~src/hooks/useGetWelfareRid"
import { WelfareExchangeType } from "~src/service/welfare/welfare"
import { useLocation } from "react-router-dom"
import useInApp from "~src/hooks/useInApp"


const Certificate: FC = () => {
  const location = useLocation()
  useDocumentTitle('我的证书')
  const [data, setData] = useState<WelfareExchangeType[]>([])
  const [visible, setVisible] = useState<boolean>(false)
  const [src, setSrc] = useState<string>()
  const lazy = useInApp()
  useGetWelfareRid((rid) => {
    getIndividualData(rid)
  }, [])
  const getIndividualData = async (rid: string) => {
    const datas = await getCertificateList()
    setData(datas.list)
  }
  const avatarUrl = useMemo(() => {
    const search = new URLSearchParams(location.search)
    return search.get('avatarUrl') || ''
  }, [location])
  return <div className={styles.certificate}>
    <div className={styles["certificate-title"]}>
      <img className={styles.certificate_title} src={certificate_title} alt="" />
      <div className={styles["certificate-info"]}>
        <div className={styles["certificate-info-boby"]}>
          <img className={styles["certificate-info-boby-img"]} src={avatarUrl} alt="" />
        </div>
        <div className={styles["certificate-info-des"]}>
          <div>
            <span>共获得：</span>
            <span className={styles["certificate-info-des-num"]}>{data.length}</span>
            <span>张</span>
          </div>
          <div>“因为您的付出，天空又蓝了一点”</div>
        </div>
      </div>
    </div>
    <div className={styles["certificate-list"]}>
      <List >
        <div className={styles["certificate-list-grid"]}>
          {
            data.length > 0 && data?.map((item, index) => {
              return <div className={styles.item}
                key={index}
                onClick={() => {
                  setSrc(item.certificateUrl)
                  setVisible(true)
                }} >
                <Image className={styles["item-img"]} lazy={!lazy} src={item.certificateUrl} ></Image>
                <div className={styles["item-txt"]}>{item.exchangeTime} 获得</div>
              </div>
            })
          }
        </div>
      </List>
      <Mask visible={visible} onMaskClick={() => setVisible(false)}  >
        <div className={styles.mask} >
          <img className={styles["mask-content"]} src={src} alt="" />
          <div className={styles["mask-txt"]}>
            <div>长按保存图片分享</div>
            <CloseOutline  onClick={() => setVisible(false)}  className={styles["mask-txt-icon"]}/>
          </div>
        </div>
      </Mask>
    </div>
  </div>
}
export default Certificate
